/**
 * API 에러 응답 인터페이스
 */
export interface ApiError {
  status: number;
  message: string;
  code?: string;
  details?: any;
  originalError?: unknown;
}

/**
 * API 페이지네이션 응답 인터페이스
 */
export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
}

/**
 * API 필터 옵션 인터페이스
 */
export interface FilterOptions {
  [key: string]: string | number | boolean | null | undefined;
}

/**
 * API 정렬 옵션 인터페이스
 */
export interface SortOptions {
  field: string;
  order: 'asc' | 'desc';
}

/**
 * API 페이지네이션 옵션 인터페이스
 */
export interface PaginationOptions {
  page?: number;
  pageSize?: number;
}

/**
 * API 요청 옵션 인터페이스
 */
export interface ApiRequestOptions {
  filters?: FilterOptions;
  sort?: SortOptions;
  pagination?: PaginationOptions;
  params?: Record<string, any>;
  headers?: Record<string, string>;
  signal?: AbortSignal;
}

/**
 * API 응답 상태 인터페이스
 */
export interface ApiResponseState<T> {
  data: T | null;
  isLoading: boolean;
  isError: boolean;
  error: ApiError | null;
}

/**
 * 토스트 메시지 옵션 인터페이스
 */
export interface ToastOptions {
  successMessage?: string;
  errorMessage?: string;
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
  onToastSuccess?: (data: any) => string;
  onToastError?: (error: ApiError) => string;
}
